export { default as UserValidatorComponent } from './user-validator';
